import { render, staticRenderFns } from "./MoveToCollection.vue?vue&type=template&id=08a0ab93&scoped=true&"
import script from "./MoveToCollection.vue?vue&type=script&lang=js&"
export * from "./MoveToCollection.vue?vue&type=script&lang=js&"
import style0 from "./MoveToCollection.vue?vue&type=style&index=0&id=08a0ab93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a0ab93",
  null
  
)

export default component.exports